import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "base-form form",
  style: {"width":"100%","max-width":"100%"}
}
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "base-form"
}
const _hoisted_12 = { style: {"width":"95%"} }
const _hoisted_13 = { style: {"float":"left"} }
const _hoisted_14 = { style: {"float":"right","color":"var(--el-text-color-secondary)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Postcard = _resolveComponent("Postcard")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_Medal = _resolveComponent("Medal")!
  const _component_counterparty_type_component = _resolveComponent("counterparty-type-component")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_User = _resolveComponent("User")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Male = _resolveComponent("Male")!
  const _component_CollectionTag = _resolveComponent("CollectionTag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_SuitcaseLine = _resolveComponent("SuitcaseLine")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_Location = _resolveComponent("Location")!
  const _component_LocationInformation = _resolveComponent("LocationInformation")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Van = _resolveComponent("Van")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_order_status_component = _resolveComponent("order-status-component")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_input_phone_component = _resolveComponent("input-phone-component")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_select_manager_component = _resolveComponent("select-manager-component")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.viewType == _ctx.ViewType.Viewing || _ctx.viewType == _ctx.ViewType.Editing)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                    _createTextVNode(" Карточка контрагента "),
                    _createElementVNode("span", null, _toDisplayString(`${_ctx.originCounterparty?.lastname ?? ''} ${ _ctx.originCounterparty?.firstname ? `${_ctx.originCounterparty?.firstname.substring(0,1)}.` : ''}`), 1)
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Новый контрагент "),
                    _createElementVNode("span", null, _toDisplayString(`${_ctx.ruleForm.lastname ?? ''} ${ _ctx.ruleForm.firstname ? `${_ctx.ruleForm.firstname.substring(0,1)}.` : ''}`), 1)
                  ])),
              (_ctx.viewType == _ctx.ViewType.Viewing || _ctx.viewType == _ctx.ViewType.Editing)
                ? (_openBlock(), _createBlock(_component_el_radio_group, {
                    key: 2,
                    modelValue: _ctx.viewType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewType) = $event)),
                    onChange: _ctx.onViewTypeChange,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, {
                        label: "Просмотр",
                        value: _ctx.ViewType.Viewing
                      }, null, 8, ["value"]),
                      _createVNode(_component_el_radio_button, {
                        label: "Редактировать",
                        value: _ctx.ViewType.Editing
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            (_ctx.viewType == _ctx.ViewType.Viewing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.originCounterparty?.id)
                    ? (_openBlock(), _createBlock(_component_el_space, {
                        key: 0,
                        alignment: "start",
                        wrap: "",
                        "fill-ratio": 49,
                        size: 20,
                        direction: "horizontal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, {
                            class: "box-card",
                            style: {"width":"640px"}
                          }, _createSlots({
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 2 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { size: "22" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Postcard)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 22 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.originCounterparty.lastname) + " " + _toDisplayString(_ctx.originCounterparty.firstname) + " " + _toDisplayString(_ctx.originCounterparty.middlename) + " ", 1),
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_el_text, {
                                            size: "small",
                                            type: "info"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" зарегистрирован " + _toDisplayString(_ctx.dateFormatter(_ctx.originCounterparty.date, false, true)), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              (_ctx.originCounterparty.types)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 0,
                                    align: "middle"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Medal)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originCounterparty.types, (t) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: t,
                                                style: {"display":"inline-block","margin-right":".3rem"}
                                              }, [
                                                _createVNode(_component_counterparty_type_component, { type: t }, null, 8, ["type"])
                                              ]))
                                            }), 128))
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  значки контрагента ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_row, {
                                align: "middle",
                                style: {"margin":".68rem 0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Phone)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 23 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_el_text, { size: "large" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.originCounterparty.phone), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createVNode(_component_el_text, {
                                        type: "info",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("  номер телефона ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.originCounterparty.manager?.id)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 1,
                                    align: "middle",
                                    gutter: 5,
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_User)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_el_text, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(`${_ctx.originCounterparty.manager.firstname}`) + " " + _toDisplayString(_ctx.originCounterparty.manager.firstname ? `${_ctx.originCounterparty.manager.firstname.substring(0,1)}.` : ''), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  менеджер ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.originCounterparty.birthdate)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 2,
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: "16" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Calendar)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_el_text, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.dateFormatter(_ctx.originCounterparty.birthdate, false, true)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  дата рождения ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_row, {
                                    key: 3,
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: "16" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Calendar)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_text, { type: "info" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" дата рождения не указана ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })),
                              _createVNode(_component_el_row, {
                                align: "middle",
                                style: {"margin":".68rem 0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Message)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 23 }, {
                                    default: _withCtx(() => [
                                      (_ctx.originCounterparty.email)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_el_link, {
                                              type: "primary",
                                              href: `mailto:${_ctx.originCounterparty.email}`,
                                              style: {"font-size":"var(--el-font-size-medium)"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.originCounterparty.email), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["href"])
                                          ]))
                                        : (_openBlock(), _createBlock(_component_el_text, {
                                            key: 1,
                                            type: "info"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" почтовый адрес не указан ")
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_ctx.originCounterparty.isMale != null)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 4,
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Male)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_text, { size: "large" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.originCounterparty.isMale === true ? 'мужчина' : (_ctx.originCounterparty.isMale === false ? 'женщина' : '')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, [
                            (_ctx.originCounterparty.notes)
                              ? {
                                  name: "footer",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_el_row, { align: "middle" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CollectionTag)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 23 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_text, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.originCounterparty.notes), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1024),
                          (_ctx.originCounterparty.legalEntity?.id)
                            ? (_openBlock(), _createBlock(_component_el_card, {
                                key: 0,
                                class: "box-card",
                                style: {"width":"640px"}
                              }, {
                                header: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_el_row, { align: "middle" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 2 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { size: "22" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_SuitcaseLine)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 22 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.name) + " ", 1),
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_el_text, {
                                                size: "small",
                                                type: "info"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" зарегистрирован " + _toDisplayString(_ctx.dateFormatter(_ctx.originCounterparty.legalEntity.date, false, true)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_row, {
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_OfficeBuilding)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_el_text, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.taxNo) + " " + _toDisplayString(_ctx.originCounterparty.legalEntity.kppNo ? `/ ${_ctx.originCounterparty.legalEntity.kppNo}` : ''), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  ИНН / КПП ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_row, {
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Location)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_el_text, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.legalAddress), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  юридический адрес ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_row, {
                                    align: "middle",
                                    style: {"margin":".68rem 0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, { span: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_LocationInformation)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_col, { span: 23 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_el_text, { size: "large" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.actualAddress), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_text, {
                                            type: "info",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("  фактический адрес ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.originCounterparty.legalEntity?.siteUrl)
                                    ? (_openBlock(), _createBlock(_component_el_row, {
                                        key: 0,
                                        align: "middle",
                                        style: {"margin":".68rem 0"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 1 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Link)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 23 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_text, { size: "large" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.siteUrl), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.originCounterparty.legalEntity?.email)
                                    ? (_openBlock(), _createBlock(_component_el_row, {
                                        key: 1,
                                        align: "middle",
                                        style: {"margin":".68rem 0"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 1 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Message)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_col, { span: 23 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_text, { size: "large" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_link, {
                                                    type: "primary",
                                                    href: `mailto:${_ctx.originCounterparty.legalEntity.email}`,
                                                    style: {"font-size":"var(--el-font-size-medium)"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.originCounterparty.legalEntity.email), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["href"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_card, { style: {"min-width":"640px"} }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 2 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { size: "22" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Van)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 22 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Автомобили ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_table, {
                                data: _ctx.originCounterparty?.vehicles
                              }, {
                                empty: _withCtx(() => [
                                  _createVNode(_component_el_text, { type: "info" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("У контрагента нет автомобилей ☹️")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    label: "Автомобиль",
                                    prop: "model"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(scope.row.model.manufacturer.name) + " " + _toDisplayString(scope.row.model.name), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "vin",
                                    label: "VIN"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "govermentalNumber",
                                    label: "Гос. номер"
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.originCounterparty?.id)
                    ? (_openBlock(), _createBlock(_component_el_space, {
                        key: 1,
                        fill: "",
                        style: {"width":"calc(100% - 2rem)","margin-top":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { size: "22" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Coin)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode("  Заказ-наряды ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_table, {
                                "row-key": "id",
                                class: "custom-loading-svg",
                                "element-loading-svg-view-box": "-10, -10, 50, 50",
                                data: _ctx.ordersList,
                                "element-loading-svg": _ctx.ordersLoadPendingSvg,
                                "default-sort": { prop: _ctx.ordersSortColumn, order: _ctx.ordersSortDir },
                                "summary-method": _ctx.calculateOrdersTotalCostSum
                              }, {
                                empty: _withCtx(() => [
                                  _createVNode(_component_el_text, { type: "info" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Контрагент еще не посетил нас ☹️")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "id",
                                    label: "№",
                                    "column-key": "id"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(scope.row.number) + " ", 1),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_order_status_component, {
                                          status: scope.row.statusId
                                        }, null, 8, ["status"])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    sortable: "",
                                    "column-key": "date",
                                    prop: "date",
                                    label: "Дата"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", null, " принят " + _toDisplayString(_ctx.dateFormatter(scope.row.date, true)), 1),
                                      (scope.row.closingDate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " завершен " + _toDisplayString(_ctx.dateFormatter(scope.row.closingDate, false)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, { label: "Менеджер" }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_link, { type: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(`${scope.row.manager.lastname} ${scope.row.manager.firstname?.substring(0,1)}.`), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "vehicle",
                                    label: "Автомобиль"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(`${scope.row.vehicle?.model?.manufacturer?.name} ${scope.row.vehicle?.model?.name}`) + " ", 1),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_el_text, { size: "small" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(scope.row.vehicle.vin), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "customer",
                                    label: "Работа"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.jobs, (j) => {
                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                          style: {"margin-right":".3rem"},
                                          type: "info",
                                          size: "small",
                                          key: j.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(j.serviceJob.component.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "customer",
                                    label: "Исполнитель",
                                    "column-key": "customerId"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.jobs, (j) => {
                                        return (_openBlock(), _createElementBlock("text", {
                                          key: j.id
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(j.assignees, (a) => {
                                            return (_openBlock(), _createBlock(_component_el_tag, {
                                              style: {"margin-right":".3rem"},
                                              type: "info",
                                              size: "small",
                                              key: a.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(a.employee?.lastname + ' ' + a.employee.firstname?.substring(0,1) + '.'), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    formatter: _ctx.tableOrderTotalCostFormatter,
                                    label: "Итого (руб.)",
                                    "column-key": "orderTotal"
                                  }, null, 8, ["formatter"])
                                ]),
                                _: 1
                              }, 8, ["data", "element-loading-svg", "default-sort", "summary-method"])
                            ]),
                            _: 1
                          })), [
                            [_directive_loading, _ctx.isOrdersLoadPending]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.viewType != _ctx.ViewType.Viewing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                    model: _ctx.ruleForm,
                    ref: "counterpartyForm",
                    "status-icon": "",
                    rules: _ctx.rules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Тип контрагента",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.ruleForm.counterpartyTypes,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.counterpartyTypes) = $event)),
                            placeholder: "Выберите из списка"
                          }, {
                            label: _withCtx((scope) => [
                              _createVNode(_component_counterparty_type_component, {
                                type: scope.value
                              }, null, 8, ["type"])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availCounterpartyTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  value: item
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_counterparty_type_component, { type: item }, null, 8, ["type"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Фамилия",
                        "label-position": "top",
                        prop: "lastname"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.lastname,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.lastname) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Имя",
                        "label-position": "top",
                        prop: "firstname"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.firstname,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.firstname) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Отчество",
                        "label-position": "top",
                        prop: "middlename"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.middlename,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.middlename) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Телефон",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_input_phone_component, {
                            modelValue: _ctx.ruleForm.phone,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.phone) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Почтовый адрес (e-mail)",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.email) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Дата рождения",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.ruleForm.birthdate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.birthdate) = $event)),
                            type: "date",
                            format: "DD.MM.YYYY",
                            placeholder: "Выберите дату рождения"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Пол",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.ruleForm.isMale,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.isMale) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_button, { value: true }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Мужчина")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_radio_button, { value: false }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Женщина")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Менеджер",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_select_manager_component, {
                            modelValue: _ctx.ruleForm.managerId,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.managerId) = $event)),
                            managers: _ctx.managers
                          }, null, 8, ["modelValue", "managers"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { "label-position": "top" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _ctx.ruleForm.isLegal,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.isLegal) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_button, { value: false }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Физическое лицо")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_radio_button, { value: true }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Юридическое лицо (ООО, ИП, ПАО, АО)")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Юридическое лицо",
                        "label-position": "top",
                        prop: "legalEntity"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_catalog_picker_component, {
                              ref: "legalEntityComponent",
                              modelValue: _ctx.ruleForm.legalEntity,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.legalEntity) = $event)),
                              disabled: !_ctx.ruleForm.isLegal,
                              placeholder: "Поиск юр. лиц по названию компании, имени или фамилии ИП, ИНН",
                              "search-url": "/api/legalentities",
                              "catalog-tab": _ctx.vehicleCatalogTab
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.ruleForm.legalEntity?.name), 1)
                              ]),
                              default: _withCtx((scope) => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(scope.name), 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(`${scope.taxNo ? `ИНН ${scope.taxNo}` : ''}`), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "catalog-tab"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Заметки",
                        "label-position": "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.notes,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.notes) = $event)),
                            maxlength: "5000",
                            "show-word-limit": "",
                            type: "textarea",
                            placeholder: "Заметки (опционально)"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.onSubmitFormClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.viewType == _ctx.ViewType.Creating ? 'Создать' : 'Сохранить'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])), [
                    [_directive_loading, _ctx.isAsyncOperationPending]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}